const EVENT_NAME = {
  touch: 'ontouchstart' in document ? 'touchstart' : 'mouseover',
}
const IGNORE_CLASS_NAME = 'no-prefetch'

export default class Prefetch {
  constructor() {
    this.ignoreClass = IGNORE_CLASS_NAME
    this.requestXhlOnComplete = () => {}
    this.requests = {}
    this.casheData = {}

    this.init()
  }

  init() {
    if (!window.history.pushState) return false
    this.addEventListeners()
  }

  addEventListeners() {
    document.body.addEventListener(EVENT_NAME.touch, this.onEnter.bind(this), { passive: true })
  }

  onEnter(event) {
    let el = event.target
    requestAnimationFrame(() => {
      while (el && !Prefetch.getHref(el)) el = el.parentNode
      if (!el || el.classList.contains(this.ignoreClass) || (el.getAttribute('target') && el.getAttribute('target') === '_blank')) return

      const url = Prefetch.getHref(el)

      if (url.indexOf('mailto:') !== -1 || url.indexOf('tel:') !== -1) return

      if (!this.getCache(url)) {
        let xml = this.requestXhl(url)
        this.setCache(url, xml)
      }
    })
  }

  requestXhl(url) {
    return new Promise((resolve) => {
      fetch(url)
        .then((res) => {
          return res.text()
        })
        .then((data) => {
          resolve(data)
        })
        .catch((error) => {})
    })
  }

  static getHref(el) {
    if (!el) {
      return undefined
    }

    if (el.getAttribute && typeof el.getAttribute('xlink:href') === 'string') {
      return el.getAttribute('xlink:href')
    }

    if (typeof el.href === 'string') {
      return el.href
    }

    return undefined
  }

  static getPort(p) {
    var port = typeof p !== 'undefined' ? p : window.location.port
    var protocol = window.location.protocol

    if (port !== '') return parseInt(port)

    if (protocol === 'http:') return 80

    if (protocol === 'https:') return 443
  }

  static cleanLink(url) {
    return url.replace(/#.*/, '')
  }

  preventCheck(evt, element) {
    if (!window.history.pushState) {
      return false
    }

    let href = this.getHref(element)

    //User
    if (!element || !href) {
      return false
    }

    //Middle click, cmd click, and ctrl click
    if (evt.which > 1 || evt.metaKey || evt.ctrlKey || evt.shiftKey || evt.altKey) {
      return false
    }

    //Ignore target with _blank target
    if (element.target && element.target === '_blank') {
      return false
    }

    //Check if it's the same domain
    if (window.location.protocol !== element.protocol || window.location.hostname !== element.hostname) {
      return false
    }

    //Check if the port is the same
    if (Prefetch.getPort() !== Prefetch.getPort(element.port)) {
      return false
    }

    //Ignore case when a hash is being tacked on the current URL
    if (href.indexOf('#') > -1) {
      return false
    }

    //Ignore case where there is download attribute
    if (element.getAttribute && typeof element.getAttribute('download') === 'string') {
      return false
    }

    //In case you're trying to load the same pages
    if (Prefetch.cleanLink(href) === Prefetch.cleanLink(location.href)) {
      return false
    }

    if (element.classList.contains(this.ignoreClass)) {
      return false
    }

    return true
  }

  getCache(key) {
    return this.casheData[key]
  }

  setCache(key, value) {
    this.casheData[key] = value
  }

  getRequestsFlag(key) {
    return this.requests[key]
  }

  setRequests(key, value) {
    this.requests[key] = true
  }
}
